import { configureStore, EnhancedStore } from 'redux-starter-kit';
import { DeepPartial } from 'redux';
import { loadUser } from 'redux-oidc';
import createSagaMiddleware from 'redux-saga';
import { all } from 'redux-saga/effects';

import monitorReducersEnhancer from './enhancers/monitorReducers';
import loggerMiddleware from './middleware/logger';
import rootReducer, { RootState } from './reducers';
import getUserManager from '../security/oidcUserManager';

import { default as appSagas } from '../App/state/sagas';

function* rootSaga() {
  yield all([appSagas()]);
}

export default function configureAppStore(
  preloadedState: DeepPartial<RootState>,
): EnhancedStore {
  const sagaMiddleware = createSagaMiddleware();

  const middleware =
    process.env.NODE_ENV !== 'production'
      ? [
          loggerMiddleware,
          require('redux-immutable-state-invariant').default(),
          sagaMiddleware,
        ] /* istanbul ignore next */
      : [loggerMiddleware, sagaMiddleware];
  const enhancers =
    process.env.NODE_ENV !== 'production'
      ? [monitorReducersEnhancer] /* istanbul ignore next */
      : [];

  const store = configureStore<RootState>({
    reducer: rootReducer,
    middleware,
    preloadedState,
    enhancers,
  });

  /* istanbul ignore next */
  if (process.env.NODE_ENV !== 'production' && module.hot) {
    /* istanbul ignore next */
    module.hot.accept('./reducers', () => store.replaceReducer(rootReducer));
  }

  loadUser(store, getUserManager());

  // Store allows us to trigger async events without creating additional saga channel.
  sagaMiddleware.setContext({ store });
  sagaMiddleware.run(rootSaga);

  return store;
}
